// import authStore from "../../stores/AuthStore";
import BaseWebSocketHandler from "./BaseWebSocketHandler";

class LogWebSocketHandler extends BaseWebSocketHandler {
  constructor() {
    const baseUrl =
      process.env.REACT_APP_WS_URL || "ws://localhost:8000/ws/logs";

    const parserFn = (rawSocketData) => {
      // console.log("raw socket data: ", rawSocketData);
      const parsed = JSON.parse(rawSocketData);
      switch (parsed.type) {
        case "log_batch":
          return { type: "log_batch", logs: parsed.logs };
        case "device_status":
          return {
            type: "device_status",
            onlineDevices: parsed.online_devices_id,
          };
        default:
          return { type: "unknown", data: parsed };
      }
    };

    super(baseUrl, parserFn);
  }

  requestLatestLogs() {
    this.send({ action: "get_latest_logs" });
  }
}

const logSocketHandler = new LogWebSocketHandler();
export default logSocketHandler;
